import { IDriver, ITruck, ITrailer, IDispatcher, ILoad } from 'apps/fleet-planner/types'
import { IExternalEntities } from 'apps/fleet-planner/types/entity'

export const isExternalDriver = (driver?: IDriver) => {
  const { id, name } = driver || {}
  return !!(!id && name)
}

export const isExternalDispatcher = (dispatcher?: IDispatcher) => {
  const { fullName, id } = dispatcher || {}
  return !!(!id && fullName)
}

export const isExternalTruck = (truck?: Partial<ITruck> | null) => {
  const { id, truckNumber } = truck || {}
  return !!(!id && truckNumber)
}

export const isExternalTrailer = (trailer?: Partial<ITrailer> | null) => {
  const { id, trailerNumber } = trailer || {}
  return !!(!id && trailerNumber)
}

export const getExternalEntities = (load: ILoad | undefined) => {
  if (!load) return {}
  const { dispatcher, drivers, trailer, truck } = load || {}
  const [firstDriver] = drivers || []
  const externalEntities: IExternalEntities = {
    isExternalDispatcher: isExternalDispatcher(dispatcher),
    isExternalTruck: isExternalTruck(truck),
    isExternalTrailer: isExternalTrailer(trailer),
    isExternalDriver: isExternalDriver(firstDriver),
  }
  return externalEntities
}
